import { render, staticRenderFns } from "./changeResultStatis.vue?vue&type=template&id=4c58e322&scoped=true&"
import script from "./changeResultStatis.vue?vue&type=script&lang=js&"
export * from "./changeResultStatis.vue?vue&type=script&lang=js&"
import style0 from "./changeResultStatis.vue?vue&type=style&index=0&id=4c58e322&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58e322",
  null
  
)

export default component.exports